import { render } from "./autorizarGastos.vue?vue&type=template&id=381c4318&scoped=true"
import script from "./autorizarGastos.vue?vue&type=script&lang=js"
export * from "./autorizarGastos.vue?vue&type=script&lang=js"

import "./autorizarGastos.vue?vue&type=style&index=0&id=381c4318&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-381c4318"]])

export default __exports__